import { render, staticRenderFns } from "./BackToTop.vue?vue&type=template&id=17bce0b4&scoped=true&"
import script from "./BackToTop.vue?vue&type=script&lang=js&"
export * from "./BackToTop.vue?vue&type=script&lang=js&"
import style0 from "./BackToTop.vue?vue&type=style&index=0&id=17bce0b4&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17bce0b4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})
